'use client'

import { OverlayButton } from '@fukku/button/Overlay/OverlayButton'
import { OverlayButtonVariant } from '@fukku/button/Overlay/types'
import type { DialogAPI } from '@fukku/dialog/Dialog'
import { IconPlusLarge } from 'icons/components/IconPlusLarge'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { dataTestIds } from 'product-card/constants/dataTestIds'
import { useAddSelectedSize } from 'product-card/hooks/useAddSelectedSize/useAddSelectedSize'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { appsAddToBag } from 'product-card/utils/appsAddToBag/appsAddToBag'
import { SizesBottomSheet } from 'product-components/components/SizeSelector/SizesBottomSheet/SizesBottomSheet'
import { useCallback, useRef } from 'react'
import type { PlpDomainData } from 'types/masterData/domainData/domainData'

export const iconSize = 16

export function OverlaySizesSheetButton({
	className,
}: {
	readonly className?: string
}) {
	const sizeSheetRef = useRef<DialogAPI>(null)
	const { isApp, custom } = useMasterData()
	const { t } = useLabels()

	const { onAdd } = useAddSelectedSize({
		opened: sizeSheetRef.current?.open ?? false,
	})
	const { dataTestId, productId, selectedColorId, lookId, location, product } =
		useProductCard()

	const handleOnClick = useCallback(() => {
		if (isApp) {
			appsAddToBag(productId, selectedColorId, lookId, custom as PlpDomainData)
		} else {
			sizeSheetRef.current?.show()
		}
	}, [isApp, productId, selectedColorId, lookId, custom])

	return (
		<>
			<OverlayButton
				className={className}
				onClick={handleOnClick}
				data-testid={dataTestIds.productCardAddToBag(dataTestId)}
				icon={
					<IconPlusLarge
						width={iconSize}
						height={iconSize}
						alt={t('productCard.showSizes.button')}
					/>
				}
				variant={OverlayButtonVariant.IconSmall}
			/>
			<SizesBottomSheet
				ref={sizeSheetRef}
				product={product}
				productId={productId}
				selectedColorId={selectedColorId}
				onSelectedSize={onAdd}
				location={location}
			/>
		</>
	)
}
